import React, {FC, useId} from 'react';
import styles from './Checkbox2.module.css';

export type UiType = 'minimal' | 'standard';

interface Props {
  /** Greys the box out; it cannot be changed. */
  disabled?: boolean;
  contentText?: string | React.ReactElement;
  /** Called once for each click on the box, its text or the row around them. */
  onCheck: () => void;
  checked: boolean;
  uiType?: UiType;
  className?: string;
  /** The id of an element that describes the checkbox, such as a hint under it. */
  ariaDescribedBy?: string;
}

const Checkbox: FC<Props> = ({
  disabled = false,
  contentText,
  onCheck,
  checked,
  uiType = 'standard',
  className,
  ariaDescribedBy,
}: Props) => {
  const id = useId();
  const getRootClass = () => {
    switch (uiType) {
      case 'minimal':
        return styles.minimal;
      case 'standard':
      default:
        return styles.standart;
    }
  };

  return (
    <div
      className={`${getRootClass()} ${styles.container} ${
        disabled ? styles.disabled : ''
      } ${className ? className : ''}`}
      // Clicks on the box and its label reach onCheck through the input's change, so the row
      // only answers clicks on itself; otherwise one click would toggle the box twice or more.
      onClick={event => {
        if (event.target === event.currentTarget && !disabled) onCheck();
      }}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={() => {
          if (!disabled) onCheck();
        }}
        aria-describedby={ariaDescribedBy}
      />
      {contentText && (
        <label htmlFor={id} className={styles.textContent}>
          {contentText}
        </label>
      )}
    </div>
  );
};

export default Checkbox;
